// --- GLOBAL VARIABLES --- //
var $window = $(window);
var $document = $(document);
var $header = $(".header");
var bpSmall = 771;
var bpMedium = 992;
var bpLarge = 1200;
var classIsActive = "is-active";
var classIsDisabled = "is-disabled";
var classIsLast = "is-last";
var classHasError = "has-error";
var classIsLoading = "is-loading";
var classIsOpened = "is-opened";
var classIsSelected = "is-selected";
var classIsCollapse = "is-collapse";
var classIsAnimated = "is-animated";
var $this = null;
var $containers = $("html,body");

// --- COMPONENTS, PARTS --- //
$(document).ready(function () {
  componentLanguage();

  // ---  COMPONENTS --- //
  // Dropdown
  // componentDropdown();

  // Benefits
  componentBenefits();

  // Footer
  componentFooter();

  // Custom
  componentCustom();

  // ChangeContent
  componentChangeContent();

  // ChangeContentIndex
  componentChangeContentIndex();

  // ChristmasCountdown
  // componentChristmasCountdown();

  // CartHeader
  componentCartHeader();

  // Registration
  componentRegistration();

  // Basket
  componentBasket();

  // Success
  componentSuccess();

  // UpdateProducts
  componentUpdateProducts();

  // // Reviews
  // componentReviews();

  // Product
  componentProduct();

  // HeaderAction
  componentHeaderAction();

  // SaleBanner
  componentSaleBanner();

  // AddHomeProducts
  componentAddHomeProducts();

  // tabs
  componentTabs();

  // detail
  componentDetail();

  // SwiperChecker
  swiperChecker();
});
// --- LOAD EVENT --- //
$(window).bind("load", function () {
  $(window).resize();
  window.addEventListener(
    "pageshow",
    function (evt) {
      // if (evt.persisted) {
      setTimeout(function () {
        // Category
        componentCategory();
        // console.log("PageShow");
        // // window.location.reload();
        // componentCategory();
      }, 1000);
      // }
    },
    false
  );
});
